import { type ExtendedAirgapAPI } from '../types';

export function isInHiddenConsentRegime(airgap: ExtendedAirgapAPI) {
  const [regime] = Array.from(airgap.getRegimes() || []);
  return regime === 'Unknown';
}
